<div class="questionContainer">
  <div class="titleContainer">
    <div class="title">{{ question.question_content }}</div>
  </div>
  <div class="contentContainer">
    <div class="answersContainer">
      @for (choice of possibleChoices; track choice; let i = $index) {
        <div class="answerContainer" dndDropzone (dndDrop)="onDrop($event, choice)">
          <div class="title" [class.green]="answerGreen[i]" [class.red]="!answerGreen[i]">
            {{ choice }}
          </div>
          <div class="choicesContainer">
            @for (possibility of getPossibilitesFor(choice); track possibility) {
              <div
                [dndDraggable]="possibility"
                [dndEffectAllowed]="'move'"
                (dndStart)="onDragStart($event, possibility)"
                (dndCanceled)="onDragCanceled($event)"
                class="possibility"
                [class.zoom-animation]="isAnimating(possibility)"
                [ngStyle]="getStyleForAnswer(possibility)"
              >
                {{ possibility }}
              </div>
            }
          </div>
        </div>
      }
    </div>
    <div dndDropzone (dndDrop)="onDrop($event, '')" class="possibilitiesContainer">
      @for (answer of answers; track answer) {
        <div
          [dndDraggable]="answer"
          [dndEffectAllowed]="'move'"
          (dndStart)="onDragStart($event, answer)"
          (dndCanceled)="onDragCanceled($event)"
          class="possibility"
          [ngStyle]="getStyleForAnswer(answer)"
        >
          {{ answer }}
        </div>
      }
    </div>
  </div>
</div>
